module.exports = __webpack_public_path__ + "media/site_templates/www.asbestosremoval.business/images/testimonials-696b2a87daaa0a86e326db5c85814993.jpg";